import { NODES } from "@repo/fika-blog/src/nodes"
import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import type { NodeSelection } from "@repo/fika-blog/src/tiptap/pm/state"
import { createEditorTransaction } from "solid-tiptap"
import { Mini } from "@/designSystem/components/mini/mini"
import { Tooltip } from "@/designSystem/components/tooltip"
import {
  DeleteButton,
  ParentButton,
  TransformButton,
} from "@/designSystem/patterns/editor-menu"

type Props = {
  editor: Editor
}
export function CodeMenu(props: Props) {
  const attributes = createEditorTransaction(
    () => props.editor,
    editor => editor.getAttributes("codeBlock"),
  )

  const selection = createEditorTransaction(
    () => props.editor,
    editor => editor.state.selection as NodeSelection,
  )

  return (
    <Mini.Menu>
      <Mini.Section>
        <ParentButton editor={props.editor} />
        <TransformButton editor={props.editor} selection={selection} />
      </Mini.Section>
      <Mini.Section>
        <Tooltip label="language">
          <Mini.TextField
            placeholder="language"
            value={attributes().language}
            onChange={language => {
              props.editor
                .chain()
                .updateAttributes(NODES.codeBlock.type, { language })
                .run()
            }}
          />
        </Tooltip>
      </Mini.Section>
      <Mini.Section>
        <DeleteButton editor={props.editor} />
      </Mini.Section>
    </Mini.Menu>
  )
}
